import React from 'react';
import { format } from 'date-fns';
import colors from 'constants/colors';
import DisplayUserEmail from './DisplayUserEmaiil';
import { Button } from 'antd';
import UpdateBugFeatureStatusButton from './UpdateBugFeatureStatusButton';
import {
  BUG_FEATURE_STATUS,
  BUG_FEATURE_TYPE,
} from 'components/blocks/BugFeatureReportForm/useBugFeatureForm';

const getBugFeatureListColumns = ({ onSelect }) => ({
  id: {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 60,
    render: (id, bugFeature) => (
      <span className="select-bug-feature" onClick={onSelect(bugFeature)}>
        {id}
      </span>
    ),
  },
  type: {
    title: '',
    dataIndex: 'type',
    key: 'type',
    width: 15,
    align: 'center',
    render: type => {
      const isBugReport = type === BUG_FEATURE_TYPE.BUG;
      return (
        <i
          className="material-icons-round"
          style={{ color: isBugReport ? colors.ERROR : colors.PRIMARY }}
        >
          {isBugReport ? 'bug_report' : 'stars'}
        </i>
      );
    },
  },
  summary: {
    title: 'Summary',
    dataIndex: 'summary',
    key: 'summary',
  },
  reporter: {
    title: 'Reporter',
    dataIndex: 'createdBy',
    key: 'createdBy',
    render: createdBy => <DisplayUserEmail id={createdBy} />,
  },
  selectedBy: {
    title: 'Selected By',
    dataIndex: 'selectedBy',
    key: 'selectedBy',
    render: selectedBy => <DisplayUserEmail id={selectedBy} />,
  },
  closedBy: {
    title: 'Closed By',
    dataIndex: 'closedBy',
    key: 'closedBy',
    render: closedBy => <DisplayUserEmail id={closedBy} />,
  },
  dateReported: {
    title: 'Date Reported',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: createdAt => format(new Date(createdAt), 'yyyy-MM-dd HH:mm'),
  },
  dateSelected: {
    title: 'Date Selected',
    dataIndex: 'selectedAt',
    key: 'selectedAt',
    render: selectedAt => format(new Date(selectedAt), 'yyyy-MM-dd HH:mm'),
  },
  dateClosed: {
    title: 'Date Closed',
    dataIndex: 'closedAt',
    key: 'closedAt',
    render: closedAt => format(new Date(closedAt), 'yyyy-MM-dd HH:mm'),
  },
  todoAction: {
    title: '',
    dataIndex: 'todoAction',
    key: 'todoAction',
    render: (_, bugFeature) => (
      <div className="flex" style={{ justifyContent: 'flex-end' }}>
        <Button.Group>
          <UpdateBugFeatureStatusButton
            dataId={bugFeature.id}
            nextStatus={BUG_FEATURE_STATUS.IN_PROGRESS}
            type={bugFeature.type}
          >
            Select
          </UpdateBugFeatureStatusButton>
          <UpdateBugFeatureStatusButton
            dataId={bugFeature.id}
            nextStatus={BUG_FEATURE_STATUS.CLOSED}
            type={bugFeature.type}
          >
            Close
          </UpdateBugFeatureStatusButton>
        </Button.Group>
      </div>
    ),
  },
  inProgressAction: {
    title: '',
    dataIndex: 'inProgressAction',
    key: 'inProgressAction',
    render: (_, bugFeature) => (
      <div className="flex" style={{ justifyContent: 'flex-end' }}>
        <UpdateBugFeatureStatusButton
          dataId={bugFeature.id}
          nextStatus={BUG_FEATURE_STATUS.CLOSED}
          type={bugFeature.type}
        >
          Close
        </UpdateBugFeatureStatusButton>
      </div>
    ),
  },
});

export default getBugFeatureListColumns;
